<template>
  <div class="row items-center justify-between">
    <SAIIconBtn
      dense
      v-if="!hidePrevious"
      :color="color"
      :icon="previousIcon"
      :disable="disablePrevious"
      :size="iconsSize"
      @click="$emit('input', dots[previousDot])"
    />
    <SAIPageDots
      :dots="dots"
      :disable="disable"
      :color="color"
      @input="$emit('input', $event)"
    />
    <SAIIconBtn
      dense
      v-if="!hideNext"
      :color="color"
      :icon="nextIcon"
      :disable="disableNext"
      :size="iconsSize"
      @click="$emit('input', dots[nextDot])"
    />
  </div>
</template>

<script>
export default {
  name: 'SAICarouselNavigation',
  props: {
    infinite: {
      type: Boolean,
      default: true
    },
    hidePrevious: Boolean,
    hideNext: Boolean,
    previousIcon: {
      type: String,
      default: 'eva-arrow-ios-back-outline'
    },
    nextIcon: {
      type: String,
      default: 'eva-arrow-ios-forward-outline'
    },
    color: {
      type: String,
      default: 'primary'
    },
    dots: {
      type: Array,
      default: () => []
    },
    disable: Boolean,
    iconsSize: {
      type: String,
      default: '20px'
    }
  },
  computed: {
    activeIndex() {
      return this.dots.findIndex((dot) => dot.active);
    },
    isFirstActive() {
      return this.activeIndex === 0;
    },
    isLastActive() {
      return this.activeIndex === this.dots.length - 1;
    },
    previousDot() {
      return this.isFirstActive ? this.dots.length - 1 : this.activeIndex - 1;
    },
    nextDot() {
      return this.isLastActive ? 0 : this.activeIndex + 1;
    },
    disablePrevious() {
      return (
        this.disable ||
        this.activeIndex < 0 ||
        (!this.infinite && this.isFirstActive) ||
        this.dots[this.previousDot].disable
      );
    },
    disableNext() {
      return (
        this.disable ||
        this.activeIndex < 0 ||
        (!this.infinite && this.isLastActive) ||
        this.dots[this.nextDot].disable
      );
    }
  },
  components: {
    SAIIconBtn: () => import('../../atom/sai-icon-btn'),
    SAIPageDots: () => import('../sai-page-dots')
  }
};
</script>
